// extracted by mini-css-extract-plugin
export default {"example":"Fdk781"};